import { configureStore } from "@reduxjs/toolkit";

import axiosInterceptor from "../helpers/axios.js";
import commonSlice from "./common/commonSlice.js";
import loginSlice from "./auth/authSlice.js";
import userSlice from "./user/userSlice.js";
import accountSlice from "./account/accountSlice.js";
import jobSlice from "./job/jobSlice.js";
import companySlice from "./company/companySlice.js";
import processSlice from "./process/processSlice.js";
import invoiceSlice from "./invoice/invoiceSlice.js";
import stageSlice from "./stage/stageSlice.js";
import profileSlice from "./profile/profileSlice.js";
import smtpSlice from "./smtp_config/smtpSlice.js";
import assignProcessSlice from "./assigntoprocess/assignprocessSlice.js";
import emailNotificationSlice from "./email_notification/emailNotificationSlice.js";
import customerSlice from "./customer/customerSlice.js";

const store = configureStore({
  devTools: true,
  reducer: {
    common: commonSlice,
    auth: loginSlice,
    user: userSlice,
    account: accountSlice,
    job: jobSlice,
    company: companySlice,
    process: processSlice,
    invoice: invoiceSlice,
    stage: stageSlice,
    profile: profileSlice,
    email_config: smtpSlice,
    assign_process: assignProcessSlice,
    email_notification: emailNotificationSlice,
    customer: customerSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

axiosInterceptor(store.dispatch);

export { store };
